import './Footer.scss';
import logo from '../../images/happy-connect-logo.png';


export default function Footer() {
  return (
    <footer className="footer">

      <div className="container footer-grid">

        {/* CONTACT */}
        <div className="col contact">
          <img src={logo} alt="logo" className="logo" />
          <h4>Contact Us</h4>
          <p>329 Marathahalli, Bengaluru,<br />Karnataka, India.</p>
          <p>+91 7204394684</p>
          <p>support@happyconnect.com</p>
        </div>

        {/* DISCOVER */}
        <div className="col">
          <h4>Discover</h4>
          <ul>
            <li>Bengalore</li>
            <li>Hyderabad</li>
            <li>Chennai</li>
            <li>Pune</li>
          </ul>
        </div>

        {/* CATEGORY */}
        <div className="col">
          <h4>Lists by Category</h4>
          <ul>
            <li>Apartment</li>
            <li>Retail</li>
            <li>House</li>
            <li>Offices</li>
            <li>Pg</li>
            <li>Villa</li>
          </ul>
        </div>

        {/* QUICK LINKS */}
        <div className="col">
          <h4>Quick Links</h4>
          <ul>
            <li>New Articles</li>
            <li>About Us</li>
            <li>Terms and Condition</li>
            <li>User’s Guide</li>
            <li>Support Center</li>
            <li>Contact Us</li>
          </ul>
        </div>

        {/* PROPERTIES */}
        <div className="col">
          <h4>Properties</h4>
          <ul>
            <li>Rented</li>
            <li>For Rent</li>
            <li>For Sale</li>
            <li>New Homes</li>
            <li>Overseas Properties</li>
          </ul>
        </div>

        {/* AGENTS */}
        <div className="col">
          <h4>Agents & Offices</h4>
          <ul>
            <li>Find an Office</li>
            <li>Find an Agent</li>
            <li>Careers</li>
            <li>Franchising</li>
            <li>Head Office</li>
          </ul>
        </div>

      </div>

      {/* BOTTOM BAR */}
      <div className="footer-bottom">
        <p>Copyright © 2026 happyconnect. All Right Reserved.</p>

        <div className="links">
          <span>Home</span>
          <span>Site Map</span>
          <span>Privacy Policy</span>
          <span>Cookie Policy</span>
        </div>
      </div>

    </footer>
  );
}